/*  ==========================================================================
    IMAGES
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initQuickrequest($element) {

    /*$element.find('.js-check .bn-request__optionals-box').on('click', function (event) {
        $element.find('.js-check .bn-request__optionals-box').removeClass('js-active');
        $(this).addClass('js-active');
    });

    $element.find('.js-radio .bn-request__optionals-box').on('click', function (event) {
        event.currentTarget.parentElement.children.forEach(function (x) {
            x.classList.remove('js-active');
        });
        event.currentTarget.classList.add('js-active');
    });
    $element.find('.bn-request__optionals').on('click', function (event) {
        $element.find('.bn-request__optionals.js-error').removeClass('js-error');
    });*/
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/eh_quickrequest.js